import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use(cfg => {
  const t = localStorage.getItem('access_token');
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

let _refreshPromise = null;

api.interceptors.response.use(
  r => r,
  async err => {
    const orig = err.config;
    if (err.response?.status === 401 && !orig._retry && orig.url !== '/auth/refresh') {
      orig._retry = true;
      const ref = localStorage.getItem('refresh_token');
      if (ref) {
        try {
          if (!_refreshPromise) {
            _refreshPromise = api.post('/auth/refresh', null, { params: { refresh_token: ref } })
              .finally(() => { _refreshPromise = null; });
          }
          const { data } = await _refreshPromise;
          localStorage.setItem('access_token', data.access_token);
          localStorage.setItem('refresh_token', data.refresh_token);
          orig.headers.Authorization = `Bearer ${data.access_token}`;
          return api(orig);
        } catch {
          localStorage.clear();
          window.location.href = '/login';
        }
      } else {
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

export default api;

export const authApi      = { login: (e,p) => api.post('/auth/login', {email:e,password:p}), me: () => api.get('/auth/me'), changePassword: (d) => api.post('/auth/change-password', d) };
export const customersApi = { list: p => api.get('/customers',{params:p}), create: d => api.post('/customers',d), get: id => api.get(`/customers/${id}`), update: (id,d) => api.put(`/customers/${id}`,d), delete: id => api.delete(`/customers/${id}`), activity: id => api.get(`/customers/${id}/activity`), saveLocation: (id, lat, lng) => api.put(`/customers/${id}/location`, { location_lat: lat, location_lng: lng }) };
export const enquiriesApi = { list: p => api.get('/enquiries',{params:p}), create: d => api.post('/enquiries',d), update: (id,d) => api.put(`/enquiries/${id}`,d), delete: id => api.delete(`/enquiries/${id}`) };
export const complaintsApi= { list: p => api.get('/complaints',{params:p}), create: d => api.post('/complaints',d), update: (id,d) => api.put(`/complaints/${id}`,d), delete: id => api.delete(`/complaints/${id}`) };
export const servicesApi  = { list: p => api.get('/services',{params:p}), create: d => api.post('/services',d), update: (id,d) => api.put(`/services/${id}`,d), delete: id => api.delete(`/services/${id}`) };
export const inventoryApi = { list: p => api.get('/inventory',{params:p}), create: d => api.post('/inventory',d), update: (id,d) => api.put(`/inventory/${id}`,d), adjustStock: (id,d) => api.post(`/inventory/${id}/stock`,d), delete: id => api.delete(`/inventory/${id}`), addSerials: (pid,serials) => api.post(`/inventory/${pid}/serials`,{serials}), deleteSerial: (pid,sid) => api.delete(`/inventory/${pid}/serials/${sid}`) };
export const salesApi     = { list: p => api.get('/sales',{params:p}), create: d => api.post('/sales',d), update: (id,d) => api.put(`/sales/${id}`,d) };
export const billsApi     = { list: p => api.get('/bills',{params:p}), create: d => api.post('/bills',d), updateStatus: (id,s) => api.put(`/bills/${id}/status`,null,{params:{status:s}}) };
export const templatesApi = { list: () => api.get('/templates'), create: d => api.post('/templates',d), update: (id,d) => api.put(`/templates/${id}`,d), delete: id => api.delete(`/templates/${id}`) };
export const staffApi     = { list: () => api.get('/staff'), create: d => api.post('/staff',d), update: (id,d) => api.put(`/staff/${id}`,d), delete: id => api.delete(`/staff/${id}`) };
export const expensesApi  = { list: p => api.get('/expenses',{params:p}), create: d => api.post('/expenses',d), update: (id,d) => api.put(`/expenses/${id}`,d), delete: id => api.delete(`/expenses/${id}`) };
export const dashboardApi    = { today: () => api.get('/dashboard/today') };
export const assignmentsApi  = { list: () => api.get('/assignments') };
export const installationsApi = { list: cid => api.get(`/installations/customers/${cid}`), create: (cid,d) => api.post(`/installations/customers/${cid}`,d), update: (iid,d) => api.put(`/installations/${iid}`,d), delete: iid => api.delete(`/installations/${iid}`) };
export const attendanceApi    = { list: p => api.get('/attendance',{params:p}), bulkMark: d => api.post('/attendance/bulk',d) };
export const auditApi         = { list: p => api.get('/audit',{params:p}) };
export const servicePickupsApi = { list: p => api.get('/service-pickups',{params:p}), create: d => api.post('/service-pickups',d), update: (id,d) => api.put(`/service-pickups/${id}`,d), delete: id => api.delete(`/service-pickups/${id}`) };
export const fieldApi      = { myAttendance: p => api.get('/field/my-attendance', { params: p }) };
export const salaryAckApi  = { my: () => api.get('/salary-acks/my'), submit: d => api.post('/salary-acks', d), list: p => api.get('/salary-acks', { params: p }) };
export const settingsApi   = { get: () => api.get('/settings'), update: d => api.put('/settings', d) };
